import { useState } from 'react'

import _ from 'lodash'
import { ItListItem } from 'types/graphql'

export default function usePromoCode(item: ItListItem) {
  const [showPromoCodeEditor, setShowPromoCodeEditor] = useState<boolean>(false)

  const allowPromoCode = !!item?.url

  React.useEffect(() => {
    setShowPromoCodeEditor(
      [
        'promoCodeCode',
        'promoCodeDiscount',
        'promoCodeValidTo',
        'promoCodeValidFrom',
      ].some((k) => !!item.product[k] && allowPromoCode)
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item.url])

  return { showPromoCodeEditor, setShowPromoCodeEditor, allowPromoCode }
}
